// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-n_hw","advertDetailParameterList__header":"c-n_hx","advertDetailParameterList__list":"c-n_hy"};